import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@shared/components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ToggleComponent } from '@shared/components/input/toggle/toggle.component';
import { PreferencesService } from '@app/core/services/preferences.service';
import { TableConfigService } from '@app/core/services/table-config.service';
import { ToastService } from '@app/core/services/toast.service';
import { TableSavedSettings } from '@shared/interfaces/table/table-saved-settings';
import { LucideAngularModule, Trash } from 'lucide-angular';

@Component({
  selector: 'app-settings-table',
  imports: [
    CardComponent,
    TranslatePipe,
    FormsModule,
    ToggleComponent,
    LucideAngularModule,
  ],
  templateUrl: './settings-table.component.html',
})
export class SettingsTableComponent implements OnInit {
  protected readonly Trash = Trash;

  public floatingTableHeader: boolean = false;
  public tableExport: boolean = true;
  public tableClipboard: boolean = true;

  public tableSettings: { tableId: string; settings: TableSavedSettings }[] = [];

  constructor(
    private readonly preferencesService: PreferencesService,
    private readonly tableConfigService: TableConfigService,
    private readonly toastService: ToastService,
  ) {}

  public ngOnInit(): void {
    this.floatingTableHeader = this.preferencesService.floatingTableHeader();
    this.tableExport = this.preferencesService.tableExport();
    this.tableClipboard = this.preferencesService.tableClipboard();
    this.updateConfigList();
  }

  public onFloatingTableHeaderChange(enabled: boolean): void {
    this.preferencesService.setFloatingTableHeader(enabled);
  }

  public onTableExportChange(enabled: boolean): void {
    this.preferencesService.setTableExport(enabled);
  }

  public onTableClipboardChange(enabled: boolean): void {
    this.preferencesService.setTableClipboard(enabled);
  }

  public clearTableConfiguration(tableId: string): void {
    this.tableConfigService.removeSettings(tableId);
    this.updateConfigList();
  }

  public clearTableConfigurations(): void {
    this.tableConfigService.removeAll();
    this.toastService.show('settings.system.table.reset');
    this.updateConfigList();
  }

  public updateConfigList(): void {
    this.tableSettings = this.tableConfigService.fetchAll();
  }
}
